import React, { useEffect, useRef, useState } from 'react';
import { api } from '@/api/client';

// Consent never publishes media or starts paid AI. Only the owner can Start.
export default function ProductVoiceConsent({ streamId }) {
  const [info,setInfo] = useState(null), [checked,setChecked] = useState(false);
  const [busy,setBusy] = useState(false), [error,setError] = useState('');
  const path = `/livestreams/${encodeURIComponent(streamId)}/owner-voice/consent`;
  const visit = useRef(null);
  const currentInfo = info?.path === path ? info : null;
  useEffect(() => {
    const epoch = {active:true,pending:false,mutating:false,revision:0};
    visit.current = epoch;
    setInfo(null); setChecked(false); setBusy(false); setError('');
    const refresh = async () => {
      if (epoch.pending || epoch.mutating) return;
      epoch.pending = true;
      const revision = epoch.revision;
      const current = () => epoch.active && visit.current === epoch && revision === epoch.revision;
      try {
        const result = await api(path,{auth:true});
        if(current()) {
          if (!result.enabled || typeof result.version !== 'string' || typeof result.notice !== 'string') throw new Error('unavailable');
          if (epoch.version !== result.version || epoch.notice !== result.notice) setChecked(false);
          epoch.version=result.version; epoch.notice=result.notice;
          setInfo({...result,path});
          setBusy(false); setError('');
        }
      }
      catch (_) { if(current()) { setInfo(null); setChecked(false); setError('AI consent is unavailable for this room. No AI start was made.'); } }
      finally { epoch.pending = false; }
    };
    refresh(); const timer=setInterval(refresh,2000);
    return () => { epoch.active=false; clearInterval(timer); };
  },[path]);
  async function consent(accepted) {
    const epoch=visit.current;
    if (!epoch?.active || epoch.mutating || busy || !currentInfo || (accepted && !checked)) return;
    epoch.mutating=true; epoch.revision++;
    setBusy(true); setError('');
    const current = () => epoch.active && visit.current === epoch;
    let confirmed = false;
    try {
      await api(path,{auth:true,method:'POST',body:{version:currentInfo.version,accepted}});
      confirmed=true;
      if(current()) { setInfo(previous => previous && {...previous,my_consent:accepted}); setChecked(false); }
    } catch (_) { if(current()) setError('Consent change could not be confirmed. Waiting for status before another request. Stop sharing your microphone if you wish to withdraw audio.'); }
    finally {
      epoch.mutating=false; epoch.revision++;
      if(current() && confirmed) setBusy(false);
    }
  }
  return <section aria-label="Cohost AI processing consent" className="tt-panel p-3 space-y-2">
    <h3>AI processing consent</h3>
    {currentInfo && <><p>{currentInfo.notice}</p><p>Consent applies to this bounded session. It does not enable your devices or start AI. The owner starts the session after all joined speakers consent. Leaving or changing membership stops AI.</p>
      {currentInfo.my_consent ? <button disabled={busy} onClick={()=>consent(false)}>Withdraw my AI consent and stop the session</button>
        : <><label><input type="checkbox" checked={checked} onChange={e=>setChecked(e.target.checked)} />I agree to this audio processing.</label><button disabled={busy || !checked} onClick={()=>consent(true)}>Give my AI consent</button></>}
    </>}
    {error && <p role="alert">{error}</p>}
  </section>;
}
